/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './footer.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../app/components/footer/footer.component';
import * as i4 from '@angular/router';
const styles_FooterComponent:any[] = [i0.styles];
export const RenderType_FooterComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FooterComponent,data:{}});
export function View_FooterComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),8,'div',[['class',
      'footer']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,
          i1.ElementRef,i1.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(3,0,(null as any),
          (null as any),4,'div',[['class','footer__container']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),1,'a',[['id',
          'privacy-link']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.FooterComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.goToPolicy()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      Cookie, Data og Privatlivspolitik\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.FooterComponent = _v.component;
    const currVal_0:any = 'footer';
    const currVal_1:any = _co.navigationClass;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_FooterComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-footer',
      ([] as any[]),(null as any),(null as any),(null as any),View_FooterComponent_0,
      RenderType_FooterComponent)),i1.ɵdid(1,114688,(null as any),0,i3.FooterComponent,
      [i4.ActivatedRoute,i4.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const FooterComponentNgFactory:i1.ComponentFactory<i3.FooterComponent> = i1.ɵccf('app-footer',
    i3.FooterComponent,View_FooterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2Zvb3Rlci9mb290ZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2Zvb3Rlci9mb290ZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9mYm9va2luZy9hbmd1bGFyLWNsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZmJvb2tpbmcvYW5ndWxhci1jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2Zvb3Rlci9mb290ZXIuY29tcG9uZW50LnRzLkZvb3RlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJmb290ZXJcIiBbbmdDbGFzc109XCJuYXZpZ2F0aW9uQ2xhc3NcIj5cbiAgPGRpdiBjbGFzcz1cImZvb3Rlcl9fY29udGFpbmVyXCI+XG4gICAgPGEgaWQ9XCJwcml2YWN5LWxpbmtcIiAoY2xpY2spPVwiZ29Ub1BvbGljeSgpXCI+XG4gICAgICBDb29raWUsIERhdGEgb2cgUHJpdmF0bGl2c3BvbGl0aWtcbiAgICA8L2E+XG4gIDwvZGl2PlxuPC9kaXY+XG4iLCI8YXBwLWZvb3Rlcj48L2FwcC1mb290ZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO21DQUFBO01BQWdELDRDQUM5QztVQUFBO1VBQUEsNENBQStCO1VBQUEsYUFDN0I7VUFBQTtRQUFBO1FBQUE7UUFBcUI7VUFBQTtVQUFBO1FBQUE7UUFBckI7TUFBQSxnQ0FBNEM7TUFFeEMsNENBQ0E7VUFBQSxTQUNGOztJQU5EO0lBQWU7SUFBcEIsV0FBSyxVQUFlLFNBQXBCOzs7O29CQ0FBO01BQUE7Z0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/footer/footer.component.ngfactory.ts